import React from 'react';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const Section3 = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
        ease: "easeInOut"
      },
    },
    exit: {
      transition: { duration: 0, delay: 0 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeInOut" } },
    exit: { opacity: 0, y: 20, transition: { duration: 0, delay: 0 } },
  };

  const photoVariants = {
    initial: { scale: 1.2, transition: { duration: 3, ease: "easeInOut" } },
    whileInView: { scale: 1, transition: { duration: 3, ease: "easeInOut" } },
    exit: { scale: 1.2, transition: { duration: 0, delay: 0 } },
  };

  const DATA = [
    {
      img:'/images/brands/kesehome/0.png',
      link:'https://www.kesehome.com/',
      isExternal: true
    },
    {
      img:'/images/brands/pioette/0.png',
      link:'https://www.pioette.com/',
      isExternal: true
    },
    {
      img:'/images/brands/cotton-lounge/0.png',
      link:'/urunler',
      isExternal: false
    },
  ];

  return (
    <motion.div
      className='bg-[#FEFDF9]'
      initial="hidden"
      whileInView="visible"
      exit="exit"
      variants={containerVariants}
    >
      <div className='grid grid-cols-10 relative group py-20'>
        <div className='col-start-2 col-span-8 z-50 flex flex-col items-center'>
          <motion.h1 variants={itemVariants} className='text-65 font-thin text-customYellow mb-10 tracking-widest'>{t("home.brands.title")}</motion.h1>

          <div className='w-1/2 grid grid-cols-1 lg:grid-cols-3 gap-3'>
            {DATA.map((logo, index) => (
              logo.isExternal ? (
                <a href={logo.link} key={index} className='hover:scale-105 duration-300' target="_blank" rel="noopener noreferrer">
                  <motion.div
                    variants={itemVariants}
                    className='w-full h-full shadow-md shadow-[#E8E4D3] flex justify-center'
                  >
                    <img src={logo.img} className='h-full object-contain' alt={`Logo ${index + 1}`} />
                  </motion.div>
                </a>
              ) : (
                <Link to={logo.link} key={index} className='hover:scale-105 duration-300'>
                  <motion.div
                    variants={itemVariants}
                    className='w-full h-full shadow-md shadow-[#E8E4D3] flex justify-center'
                  >
                    <img src={logo.img} className='h-full object-contain' alt={`Logo ${index + 1}`} />
                  </motion.div>
                </Link>
              )
            ))}
          </div>
        </div>
      </div>

      <motion.img
        src='/images/home/yellow.png'
        className='h-[60vh] w-full object-cover mix-blend-multiply'
        style={{ objectPosition: '0 20%' }}
        initial="initial"
        whileInView="whileInView"
        exit="exit"
        variants={photoVariants}
      />
    </motion.div>
  );
};

export default Section3;
